/* Marked Memory v12: shared behavior (header drawer, header shadow, homepage bundle cards). */
(function () {
  'use strict';
  var MENU = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M4 8h16M4 16h16"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  /* Phone drawer */
  var btn = document.querySelector('.site-header__menu');
  var drawer = document.getElementById('site-drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      btn.innerHTML = open ? MENU : CLOSE;
      drawer.hidden = open;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
  }

  /* Homepage bundle cards: selected class + CTA carries the chosen quantity */
  Array.prototype.forEach.call(document.querySelectorAll('.mm-bundle'), function (group) {
    var sync = function () {
      var checked = group.querySelector('input:checked');
      Array.prototype.forEach.call(group.querySelectorAll('.mm-bundle-option'), function (opt) {
        opt.classList.toggle('mm-bundle-option--selected', !!checked && opt.contains(checked));
      });
      if (checked) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-bundle-cta]'), function (a) {
          var base = a.getAttribute('data-base') || a.getAttribute('href').split('?')[0];
          a.setAttribute('href', checked.value === '2' ? base + '?mugs=2' : base);
        });
      }
    };
    group.addEventListener('change', sync);
    sync();
  });

  /* Header shadow once scrolled */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Footer newsletter: after Shopify's redirect (#mm-newsletter / ?customer_posted=true) keep the message in view */
  if (/customer_posted=true/.test(location.search) || location.hash === '#mm-newsletter') {
    var msg = document.querySelector('.site-news__msg');
    if (msg && !msg.textContent.trim()) msg.textContent = 'Thanks. You’re on the list.';
  }

  /* v18: keep product URLs clean. Shopify/Teeinblue append ?variant=ID; strip it from the address bar (display only, the selected variant is unaffected). */
  (function () {
    var clean = function (url) {
      if (url == null) return url;
      try {
        var u = new URL(url, location.href);
        if (u.origin !== location.origin || !u.searchParams.has('variant')) return url;
        u.searchParams.delete('variant');
        return u.pathname + u.search + u.hash;
      } catch (e) { return url; }
    };
    ['replaceState', 'pushState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function (state, title, url) { return orig.call(history, state, title, clean(url)); };
    });
    var strip = function () { var c = clean(location.href); if (c !== location.href && c.charAt(0) === '/') history.replaceState(history.state, '', c); };
    if (document.readyState === 'complete') strip(); else window.addEventListener('load', strip);
    setTimeout(strip, 1500);
  })();
})();
